import { HttpErrorResponse } from '@angular/common/http';

/**
 * Mensaje de error para create/update de workflow (NIF-882).
 * Prioridad: 1009 diseño → msg API (1010/validación) → bag Laravel `errors` → fallback i18n.
 */
export function resolveWorkflowMutationErrorMessage(
	error: HttpErrorResponse | null | undefined,
	fallback: string,
	designCompanyMessage: string,
): string {
	const apiError = error?.error?.error;
	if (apiError?.error_code === 1009) {
		return designCompanyMessage;
	}

	const apiMsg = apiError?.msg;
	if (typeof apiMsg === 'string' && apiMsg.trim() !== '') {
		return apiMsg.trim();
	}

	const laravelErrors = error?.error?.errors;
	if (laravelErrors && typeof laravelErrors === 'object') {
		for (const value of Object.values(laravelErrors as Record<string, unknown>)) {
			if (Array.isArray(value) && typeof value[0] === 'string' && value[0].trim() !== '') {
				return value[0].trim();
			}
			if (typeof value === 'string' && value.trim() !== '') {
				return value.trim();
			}
		}
	}

	const topMessage = error?.error?.message;
	if (typeof topMessage === 'string' && topMessage.trim() !== '') {
		return topMessage.trim();
	}

	return fallback;
}
